import axios from '@/libs/api.request'

class SearchQueryBuilder {
  constructor() {
    this.queryString = ''
    this.data = {}
  }

  buildQueryString (options, method) {
    var queryBuilder = this

    queryBuilder.clear()

    if (options['q'] && Object.keys(options['q']).length > 0) {
      queryBuilder.addQ(options['q'])
    }

    if (options['query_raw'] && Object.keys(options['query_raw']).length > 0) {
      queryBuilder.addQueryRaw(options['query_raw'])
    }

    if (options['includes'] && Object.keys(options['includes']).length > 0) {
      queryBuilder.addIncludes(options['includes'])
    }

    if (options['appends'] && Object.keys(options['appends']).length > 0) {
      queryBuilder.addAppends(options['appends'])
    }

    if (options['filters'] && Object.keys(options['filters']).length > 0) {
      queryBuilder.addFilters(options['filters'])
    }

    if (options['ranges'] && Object.keys(options['ranges']).length > 0) {
      queryBuilder.addRangeFilters(options['ranges'])
    }

    if (options['paginate'] && Object.keys(options['paginate']).length > 0) {
      queryBuilder.addPagination(options['paginate'])
    }

    if (options['sort'] && Object.keys(options['sort']).length > 0) {
      queryBuilder.addSort(options['sort'])
    }

    if (options['aggs'] && Object.keys(options['aggs']).length > 0) {
      queryBuilder.addAggs(options['aggs'])
    }

    if (method === 'get') {
      return this.queryString
    } else {
      return this.data
    }
  }

  clear () {
    // query string is used in GET method.
    this.queryString = ''
    // Data is being used in POST method
    this.data = {}
  }

  /**
   * Escape special characters.
   * @param {string} value
   */
  safeValue (value) {
    // We have left ? and * characters in the original string for wild matching
    let regex = /[+\-=&|><!(){}[\]^":\\/]/g
    return value.replace(regex, '\\$&')
  }

  /**
   * Alias for addQ
   */
  q (options) {
    this.addQ(options)
  }

  transformQueryString (query) {
    if (typeof query === 'object') {
      query = Object.entries(query).reduce((a, [k, v]) => {
        if (v) {
          if (typeof v === 'object') {
            if (v.value) {
              // { value: 'text', suffix: '*', prefix: '*' }
              v = Object.assign({ prefix: '', suffix: '' }, v)
              a.push(k + ':' + v.prefix + v.value + v.suffix)
            }
          } else {
            a.push(k + ':' + v)
          }
        }
        return a
      }, [])
      return query.length > 0 ? query.join(' AND ') : '*'
    } else {
      return query
    }
  }

  addQ (query) {
    let queryString = this.transformQueryString(query)
    this.append('q=' + queryString)
    this.setParams('q', queryString)
    return this
  }

  addIncludes (includes) {
    let value = Object.keys(includes).map(index => 'includes[]=' + includes[index]).join('&')
    this.append(value)
    this.setParams('includes', includes)
    return this
  }

  addAppends(appends) {
    let value = Object.keys(appends).map(index => 'appends[]=' + appends[index]).join('&')
    this.append(value)
    this.setParams('appends', appends)
    return this
  }

  addFilters (filters) {
    let value = Object.keys(filters).map(key => 'filters[' + key + ']=' + filters[key]).join('&')
    this.append(value)
    this.setParams('filters', filters)
    return this
  }

  addRangeFilters (ranges) {
    let value = Object.keys(ranges).map(field => Object.keys(ranges[field]).map(op => 'ranges[' + field + '][' + op + ']=' + ranges[field][op]).join('&'))
    this.append(value)
    this.setParams('ranges', ranges)
    return this
  }

  addSort (sort) {
    let value = Object.keys(sort).map(field => `sort[${field}]=${sort[field]}`).join('&')
    this.append(value)
    this.setParams('sort', sort)
    return this
  }

  addAggs (aggs) {
    let jsonString = JSON.stringify(aggs)
    this.append(`aggs=${jsonString}`)
    this.setParams('aggs', aggs)
    return this
  }

  addQueryRaw (query) {
    let jsonString = JSON.stringify(query)
    this.append(`query_raw=${jsonString}`)
    this.setParams('query_raw', query)
    return this
  }

  addPagination ({ size = 15, page = 1 }) {
    this.append(`size=${size}&page=${page}`)
    this.setParams('size', size)
    this.setParams('page', page)
    return this
  }

  append (value) {
    if (this.queryString.length === 0) {
      this.queryString = value
    } else {
      this.queryString = this.queryString + '&' + value
    }
  }

  setParams (key, value) {
    if (key) {
      this.data[key] = value
    }
  }
}

export const search = (type, query) => {
  return axios.request({
    url: 'search',
    method: 'get',
    params: {
      type: type,
      q: query
    }
  })
}

export const eloquentsearch = (
  type,
  query,
  options = { filters: {}, ranges: {}, includes: [], size: 15, sort: {}, page: 1, aggs: {}, query_raw: {}, appends: [] },
  method = 'get'
) => {
  let path = `search/${type}`
  if (query && !typeof query === 'string') {
    query = JSON.stringify(query)
  }
  let searchQueryBuilder = new SearchQueryBuilder()
  if (method === 'get') {
    path = path + '?' + searchQueryBuilder.buildQueryString(Object.assign({}, { q: query }, options), method)
    return axios.request({ url: path, method })
  } else {
    let data = searchQueryBuilder.buildQueryString(Object.assign({}, { q: query }, options), method)
    return axios.request({ url: path, method, data: data })
  }
}
export const getComponentPrice = (id) => {
  return axios.request({
    url: `etl/component-price/${id}`,
    method: 'get'
  })
}

export const searchQueryBuilder = new SearchQueryBuilder()
